const initialState = {
  loaded: false,
  accounts: []
}

const pullCalendarsFor = ({ id, email, kind, calendars, pull_calendar_ids: pullCalendarIds }) => ({
  id,
  email,
  kind,
  pull_calendars: calendars.filter((x) => pullCalendarIds.includes(x.id))
})

export default (state = initialState, action) => {
  switch (action.type) {
    case 'SET_CALENDAR_ACCOUNTS': {
      const accounts = action.payload.accounts.map((account) => pullCalendarsFor(account))
      return {
        loaded: true,
        accounts
      }
    }
    default:
      return state
  }
}
